import { render, staticRenderFns } from "./TaxReturnDeductionsSection.vue?vue&type=template&id=73acabd8&scoped=true&"
import script from "./TaxReturnDeductionsSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnDeductionsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73acabd8",
  null
  
)

export default component.exports